/**
 * @desc 分页查询列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.CenterCountyMappingResponseDto>
>;
export function request(
  params: API.basics.centerCountyMapping.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/centerCountyMapping/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
